import api from '../api';

export const getJobDetails = async (jobId) => {
    const res = await api.post(`/job/getJobDetailsForBoth/${jobId}`);
    return res.data;
}

